import { GRAPHS } from 'modules/campaigns/constants/graphTypes';
import CampaignGraphTooltip from '../../../components/Tooltips/CampainGraphTooltip';
import * as FIELDS from '../../fields';
import metrics from '../../metrics';

const graph = {
    type: GRAPHS.BAR,
    endpoint: 'campaign-report-by-attribution-group',
    metrics: [
        metrics.VISIBLE_IMPRESSIONS,
        metrics.VCTR,
        metrics.CLICKS,
        metrics.AVERAGE_CPC,
        metrics.VCPM,
        metrics.CVR,
        metrics.CONVERSIONS,
        metrics.CPA,
        metrics.SPENT,
    ],
    maxAllowedSelectedMetrics: 4,
    maxXAxisValues: 8,
    shouldUseGridDataSrc: true,
    displayTotalsInLegendRow: false,
    enableLongTextTickFormatting: true,
    graphProps: {
        xAxisDataKey: FIELDS.ATTRIBUTION_GROUP.field,
    },
    graphTooltip: CampaignGraphTooltip,
};

export default graph;
